'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Rules;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Currently, `rules` stores the plaintext output from the host as an array. Each
item in the array is a string representing a line of the terminal output.
*/

function Rules(_ref) {
  var rules = _ref.rules,
      style = _ref.style;

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'Rules' },
    _react2.default.createElement(
      'tbody',
      null,
      rules && rules.map(function (rulesLine, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: style },
            _react2.default.createElement(
              'span',
              null,
              rulesLine
            )
          )
        );
      })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/common/Rules.jsx
// module id = 654
// module chunks = 0